import React from "react";
import Dialog from "Components/Fragment/Dialog";
import { Box } from "Components/Base/Layout/Box";
import withLanguageContext from "lib/hocs/withLanguageContext";
import { isStandardActivityType } from "lib/utils";
import { sanitize } from "lib/sanitizer";

const detailTextSx = {
  fontFamily: "var(--primaryTextFont)",
  fontWeight: "var(--primaryTextFontWeight, 400)",
  lineHeight: 1.5,
};

const DetailRow = ({ label, value }) => (
  <Box sx={{ mb: 1, ...detailTextSx }}>
    <label className="bold">{label}: </label>
    <span>{value}</span>
  </Box>
);

const DetailBlock = ({ label, children }) => (
  <Box sx={{ mt: 1, mb: 1, ...detailTextSx }}>
    <Box component="label" className="bold" sx={{ display: "block", mb: 0.5 }}>
      {label}
    </Box>
    {children}
  </Box>
);

const EducationHistoryDetailDialog = ({ course, onClose, languageContext }) => {
  if (!course) {
    return null;
  }

  const normalizedType =
    typeof course.type === "string" ? course.type.toLowerCase() : course.type;
  const typeLabel = isStandardActivityType(normalizedType)
    ? languageContext(normalizedType)
    : course.type || "";

  const hours =
    course.hours != null && course.hours !== "" ? String(course.hours) : "";
  const minutes =
    course.minutes != null && course.minutes !== ""
      ? String(course.minutes)
      : "";

  const descriptionHtml = sanitize(course.description || "");

  return (
    <Dialog
      title={languageContext("editactivity2")}
      open
      maxWidth="md"
      fullWidth
      cancelText={languageContext("close")}
      closeTitle={languageContext("close")}
      onClose={onClose}
      text={
        <Box sx={{ py: 1 }}>
          <DetailRow
            label={languageContext("title")}
            value={course.title || ""}
          />
          <DetailRow label={languageContext("type")} value={typeLabel} />
          <DetailBlock label={languageContext("description")}>
            <Box
              id="educationhistory-detail-description"
              component="span"
              sx={{
                whiteSpace: "pre-wrap",
                display: "block",
                maxWidth: 680,
                minHeight: 72,
              }}
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
              aria-label={languageContext("description")}
            />
          </DetailBlock>
          <DetailRow label={languageContext("hours")} value={hours} />
          <DetailRow label={languageContext("minutes")} value={minutes} />
          <DetailRow
            label={languageContext("enddate")}
            value={course.endDate || ""}
          />
        </Box>
      }
    />
  );
};

export default withLanguageContext(
  EducationHistoryDetailDialog,
  "TalentManagement",
);
